import { IsNumber, IsOptional, IsString, Max, Min } from 'class-validator';
import {
  MAX_DIGITAL_CARD_AMOUNT,
  MIN_DIGITAL_CARD_AMOUNT,
} from '../../constants/gift-card/gift-card.constants';

export class CreateAndActivateGiftCardRequestDto {
  @IsString()
  readonly customerName: string;

  @IsString()
  readonly customerEmail: string;

  @IsNumber()
  @Max(MAX_DIGITAL_CARD_AMOUNT)
  @Min(MIN_DIGITAL_CARD_AMOUNT)
  readonly cardValue: number;

  @IsNumber()
  readonly merchantPaymentMethodId: number;

  @IsString()
  readonly approvalCode: string;

  @IsOptional()
  @IsNumber()
  readonly giftCardTypeId?: number;
}
